import { render } from "./KalaO.vue?vue&type=template&id=671ee0ed&scoped=true"
import script from "./KalaO.vue?vue&type=script&lang=js"
export * from "./KalaO.vue?vue&type=script&lang=js"

import "./KalaO.vue?vue&type=style&index=0&id=671ee0ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671ee0ed"]])

export default __exports__